// src/components/Dialogs/ConfirmReplaceDialog.jsx
import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from '@mui/material';

export default function ConfirmReplaceDialog({
  open,
  currentTitle,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Replace Asset Upload Form?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          An Asset Upload Form is already published for this organization
          {currentTitle ? ` (“${currentTitle}”)` : ''}. Do you want to
          replace it with this form?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
}
